import { useEffect, useRef } from 'react';
import { Box, CircularProgress } from '@mui/material';
import SetPassword from '../login/SetPassword';
import { useSession } from '../../contexts/session-context';
import { postLoginDestination } from '../login/post-login-destination';

export default function HubSetPasswordPage() {
    const { authorize, status, isAuthenticated, user } = useSession();
    const redirected = useRef(false);

    useEffect(() => {
        // Only check the session once. After a client-side navigation between hub pages it is
        // already resolved, and re-running `authorize` would flip `status` back to 'loading' and
        // swap the whole page for the bare spinner (a white flash).
        if (status !== 'idle') return;
        authorize();
    }, [authorize, status]);

    useEffect(() => {
        if (!isAuthenticated || redirected.current) return;
        redirected.current = true;
        // UX-799: saving the password authenticates the session, which also fires this "already
        // signed in" redirect — route it the same place sign-in would (ROBO-478), so it doesn't
        // overrule SetPassword's own navigate for a suspended business's Owner.
        window.location.replace(postLoginDestination(user));
    }, [isAuthenticated, user]);

    if (status === 'loading' || status === 'idle' || isAuthenticated) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height: '100vh', width: '100vw', overflow: 'hidden' }}
            >
                <CircularProgress color="inherit" size={32} sx={{ opacity: 0.25 }} />
            </Box>
        );
    }

    return <SetPassword />;
}
